@file:OptIn(InternalResourceApi::class)

package gero.composeapp.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.LanguageQualifier
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String = "composeResources/gero.composeapp.generated.resources/"

@delegate:ResourceContentHash(1_626_332_367)
internal val Res.string.month_february: StringResource by lazy {
      StringResource("string:month_february", "month_february", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 196889, 34),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 194177, 34),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 195126, 34),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 186425, 34),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 182309, 34),
      ))
    }

@delegate:ResourceContentHash(-2_024_173_876)
internal val Res.string.month_january: StringResource by lazy {
      StringResource("string:month_january", "month_january", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 196924, 29),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 194212, 29),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 195161, 33),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 186460, 33),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 182344, 33),
      ))
    }

@delegate:ResourceContentHash(775_806_601)
internal val Res.string.month_july: StringResource by lazy {
      StringResource("string:month_july", "month_july", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 196954, 26),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 194242, 26),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 195195, 30),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 186494, 26),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 182378, 26),
      ))
    }

@delegate:ResourceContentHash(260_116_162)
internal val Res.string.month_june: StringResource by lazy {
      StringResource("string:month_june", "month_june", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 196981, 26),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 194269, 26),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 195226, 26),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 186521, 26),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 182405, 26),
      ))
    }

@delegate:ResourceContentHash(-1_361_314_611)
internal val Res.string.month_march: StringResource by lazy {
      StringResource("string:month_march", "month_march", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 197008, 27),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 194296, 27),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 195253, 27),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 186548, 27),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 182432, 27),
      ))
    }

@delegate:ResourceContentHash(1_222_143_576)
internal val Res.string.month_may: StringResource by lazy {
      StringResource("string:month_may", "month_may", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 197036, 21),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 194324, 25),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 195281, 21),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 186576, 25),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 182460, 21),
      ))
    }

@delegate:ResourceContentHash(-1_125_038_283)
internal val Res.string.month_november: StringResource by lazy {
      StringResource("string:month_november", "month_november", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 197058, 34),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 194350, 34),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 195303, 34),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 186602, 34),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 182482, 34),
      ))
    }

@delegate:ResourceContentHash(-1_329_469_488)
internal val Res.string.month_october: StringResource by lazy {
      StringResource("string:month_october", "month_october", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 197093, 33),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 194385, 33),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 195338, 33),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 186637, 33),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 182517, 33),
      ))
    }

@delegate:ResourceContentHash(154_185_943)
internal val Res.string.month_september: StringResource by lazy {
      StringResource("string:month_september", "month_september", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 197127, 35),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 194419, 39),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 195372, 35),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 186671, 35),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 182551, 35),
      ))
    }

@delegate:ResourceContentHash(1_391_439_693)
internal val Res.string.must_accept_terms_error: StringResource by lazy {
      StringResource("string:must_accept_terms_error", "must_accept_terms_error", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 197163, 115),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 194459, 91),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 195408, 95),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 186707, 87),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 182587, 83),
      ))
    }

@delegate:ResourceContentHash(1_403_565_874)
internal val Res.string.new_user_register_here: StringResource by lazy {
      StringResource("string:new_user_register_here", "new_user_register_here", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 197279, 74),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 194551, 78),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 195504, 78),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 186795, 70),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 182671, 62),
      ))
    }

@delegate:ResourceContentHash(-2_021_538_079)
internal val Res.string.next_month_desc: StringResource by lazy {
      StringResource("string:next_month_desc", "next_month_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 197354, 43),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 194630, 43),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 195583, 39),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 186866, 43),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 182734, 39),
      ))
    }

@delegate:ResourceContentHash(-13_446_111)
internal val Res.string.no_hearts_ad_loading_btn: StringResource by lazy {
      StringResource("string:no_hearts_ad_loading_btn", "no_hearts_ad_loading_btn", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 197398, 64),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 194674, 60),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 195623, 72),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 186910, 68),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 182774, 52),
      ))
    }

@delegate:ResourceContentHash(1_607_746_584)
internal val Res.string.no_hearts_ad_unavailable_btn: StringResource by lazy {
      StringResource("string:no_hearts_ad_unavailable_btn", "no_hearts_ad_unavailable_btn", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 197463, 80),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 194735, 88),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 195696, 96),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 186979, 92),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 182827, 72),
      ))
    }

@delegate:ResourceContentHash(507_320_745)
internal val Res.string.no_hearts_benefit_accessories_desc: StringResource by lazy {
      StringResource("string:no_hearts_benefit_accessories_desc", "no_hearts_benefit_accessories_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 197544, 162),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 194824, 158),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 195793, 142),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 187072, 162),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 182900, 118),
      ))
    }

@delegate:ResourceContentHash(-558_975_839)
internal val Res.string.no_hearts_benefit_accessories_title: StringResource by lazy {
      StringResource("string:no_hearts_benefit_accessories_title", "no_hearts_benefit_accessories_title", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 197707, 91),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 194983, 95),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 195936, 95),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 187235, 79),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 183019, 79),
      ))
    }

@delegate:ResourceContentHash(-718_414_915)
internal val Res.string.no_hearts_benefit_builder_desc: StringResource by lazy {
      StringResource("string:no_hearts_benefit_builder_desc", "no_hearts_benefit_builder_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 197799, 106),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 195079, 102),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 196032, 122),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 187315, 110),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 183099, 106),
      ))
    }

@delegate:ResourceContentHash(957_087_255)
internal val Res.string.no_hearts_benefit_builder_title: StringResource by lazy {
      StringResource("string:no_hearts_benefit_builder_title", "no_hearts_benefit_builder_title", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 197906, 79),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 195182, 79),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 196155, 87),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 187426, 71),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 183206, 75),
      ))
    }

@delegate:ResourceContentHash(-645_790_263)
internal val Res.string.no_hearts_benefit_hearts_desc: StringResource by lazy {
      StringResource("string:no_hearts_benefit_hearts_desc", "no_hearts_benefit_hearts_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 197986, 101),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 195262, 105),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 196243, 117),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 187498, 109),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 183282, 105),
      ))
    }

@delegate:ResourceContentHash(1_814_722_964)
internal val Res.string.no_hearts_benefit_hearts_title: StringResource by lazy {
      StringResource("string:no_hearts_benefit_hearts_title", "no_hearts_benefit_hearts_title", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 198088, 62),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 195368, 66),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 196361, 62),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 187608, 58),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 183388, 62),
      ))
    }

@delegate:ResourceContentHash(224_370_753)
internal val Res.string.no_hearts_benefit_onetime_desc: StringResource by lazy {
      StringResource("string:no_hearts_benefit_onetime_desc", "no_hearts_benefit_onetime_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 198151, 90),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 195435, 102),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 196424, 90),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 187667, 98),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 183451, 90),
      ))
    }

@delegate:ResourceContentHash(-540_742_973)
internal val Res.string.no_hearts_benefit_onetime_title: StringResource by lazy {
      StringResource("string:no_hearts_benefit_onetime_title", "no_hearts_benefit_onetime_title", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 198242, 59),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 195538, 71),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 196515, 55),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 187766, 75),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 183542, 63),
      ))
    }

@delegate:ResourceContentHash(1_674_405_153)
internal val Res.string.no_hearts_feedback: StringResource by lazy {
      StringResource("string:no_hearts_feedback", "no_hearts_feedback", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 198302, 94),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 195610, 82),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 196571, 94),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 187842, 78),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 183606, 74),
      ))
    }

@delegate:ResourceContentHash(786_090_685)
internal val Res.string.no_hearts_maybe_later_btn: StringResource by lazy {
      StringResource("string:no_hearts_maybe_later_btn", "no_hearts_maybe_later_btn", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 198397, 57),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 195693, 57),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 196666, 61),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 187921, 57),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 183681, 49),
      ))
    }

@delegate:ResourceContentHash(1_786_284_508)
internal val Res.string.no_hearts_onetime_notice: StringResource by lazy {
      StringResource("string:no_hearts_onetime_notice", "no_hearts_onetime_notice", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 198455, 80),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 195751, 76),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 196728, 80),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 187979, 84),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 183731, 80),
      ))
    }

@delegate:ResourceContentHash(1_185_499_513)
internal val Res.string.no_hearts_subtitle: StringResource by lazy {
      StringResource("string:no_hearts_subtitle", "no_hearts_subtitle", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 198536, 74),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 195828, 66),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 196809, 74),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 188064, 70),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 183812, 66),
      ))
    }

@delegate:ResourceContentHash(1_096_897_347)
internal val Res.string.no_hearts_title: StringResource by lazy {
      StringResource("string:no_hearts_title", "no_hearts_title", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 198611, 67),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 195895, 67),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 196884, 55),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 188135, 51),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 183879, 51),
      ))
    }

@delegate:ResourceContentHash(896_166_964)
internal val Res.string.no_hearts_unlock_btn: StringResource by lazy {
      StringResource("string:no_hearts_unlock_btn", "no_hearts_unlock_btn", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 198679, 60),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 195963, 60),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 196940, 60),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 188187, 52),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 183931, 48),
      ))
    }

@delegate:ResourceContentHash(1_056_429_250)
internal val Res.string.no_hearts_upsell_full_version: StringResource by lazy {
      StringResource("string:no_hearts_upsell_full_version", "no_hearts_upsell_full_version", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 198740, 173),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 196024, 193),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 197001, 197),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 188240, 181),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 183980, 169),
      ))
    }

@delegate:ResourceContentHash(-2_089_460_448)
internal val Res.string.no_hearts_wait_tomorrow_sub: StringResource by lazy {
      StringResource("string:no_hearts_wait_tomorrow_sub", "no_hearts_wait_tomorrow_sub", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 198914, 83),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 196218, 79),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 197199, 79),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 188422, 75),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 184150, 71),
      ))
    }

@delegate:ResourceContentHash(-515_579_333)
internal val Res.string.no_hearts_watch_ad_btn: StringResource by lazy {
      StringResource("string:no_hearts_watch_ad_btn", "no_hearts_watch_ad_btn", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 198998, 102),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 196298, 102),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 197279, 98),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 188498, 82),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 184222, 74),
      ))
    }

@delegate:ResourceContentHash(976_400_914)
internal val Res.string.no_hiero_found: StringResource by lazy {
      StringResource("string:no_hiero_found", "no_hiero_found", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 199101, 62),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 196401, 78),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 197378, 58),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 188581, 58),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 184297, 50),
      ))
    }

@delegate:ResourceContentHash(-435_869_947)
internal val Res.string.no_rule_found: StringResource by lazy {
      StringResource("string:no_rule_found", "no_rule_found", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 199164, 53),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 196480, 69),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 197437, 53),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 188640, 53),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 184348, 41),
      ))
    }

@delegate:ResourceContentHash(1_670_394_026)
internal val Res.string.no_title: StringResource by lazy {
      StringResource("string:no_title", "no_title", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 199218, 52),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 196550, 52),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 197491, 52),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 188694, 52),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 184390, 52),
      ))
    }

@delegate:ResourceContentHash(-1_923_884_634)
internal val Res.string.no_word_found: StringResource by lazy {
      StringResource("string:no_word_found", "no_word_found", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 199271, 53),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 196603, 69),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 197544, 45),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 188747, 53),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 184443, 41),
      ))
    }

@delegate:ResourceContentHash(2_092_897_956)
internal val Res.string.oh_no_title: StringResource by lazy {
      StringResource("string:oh_no_title", "oh_no_title", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 199325, 31),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 196673, 31),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 197590, 31),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 188801, 27),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 184485, 27),
      ))
    }

@delegate:ResourceContentHash(1_416_141_051)
internal val Res.string.or_divider: StringResource by lazy {
      StringResource("string:or_divider", "or_divider", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 199357, 26),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 196705, 22),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 197622, 22),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 188829, 26),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 184513, 22),
      ))
    }

@delegate:ResourceContentHash(1_395_417_806)
internal val Res.string.password_label: StringResource by lazy {
      StringResource("string:password_label", "password_label", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 199384, 34),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 196728, 38),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 197645, 38),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 188856, 34),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 184536, 34),
      ))
    }

@delegate:ResourceContentHash(383_208_240)
internal val Res.string.perfect_stars_desc: StringResource by lazy {
      StringResource("string:perfect_stars_desc", "perfect_stars_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 199419, 114),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 196767, 114),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 197684, 114),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 188891, 106),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 184571, 98),
      ))
    }

@delegate:ResourceContentHash(1_263_433_259)
internal val Res.string.placeholder_write_translation: StringResource by lazy {
      StringResource("string:placeholder_write_translation", "placeholder_write_translation", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 199534, 81),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 196882, 81),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 197799, 73),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 188998, 73),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 184670, 77),
      ))
    }

@delegate:ResourceContentHash(-2_039_273_243)
internal val Res.string.plural_dual: StringResource by lazy {
      StringResource("string:plural_dual", "plural_dual", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 199616, 151),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 196964, 139),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 197873, 139),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 189072, 131),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 184748, 135),
      ))
    }

@delegate:ResourceContentHash(-590_751_994)
internal val Res.string.plural_triple: StringResource by lazy {
      StringResource("string:plural_triple", "plural_triple", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 199768, 89),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 197104, 65),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 198013, 81),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 189204, 65),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 184884, 73),
      ))
    }

@delegate:ResourceContentHash(-1_900_893_743)
internal val Res.string.plural_w: StringResource by lazy {
      StringResource("string:plural_w", "plural_w", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 199858, 160),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 197170, 120),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 198095, 136),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 189270, 120),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 184958, 124),
      ))
    }

@delegate:ResourceContentHash(-1_039_134_289)
internal val Res.string.previous_month_desc: StringResource by lazy {
      StringResource("string:previous_month_desc", "previous_month_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 200019, 51),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 197291, 43),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 198232, 51),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 189391, 47),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 185083, 47),
      ))
    }

@delegate:ResourceContentHash(-1_425_864_639)
internal val Res.string.privacy_policy_label: StringResource by lazy {
      StringResource("string:privacy_policy_label", "privacy_policy_label", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 200071, 56),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 197335, 60),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 198284, 68),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 189439, 48),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 185131, 48),
      ))
    }

@delegate:ResourceContentHash(1_746_080_931)
internal val Res.string.profile_alyn_colors_count: StringResource by lazy {
      StringResource("string:profile_alyn_colors_count", "profile_alyn_colors_count", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 200128, 69),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 197396, 81),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 198353, 77),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 189488, 81),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 185180, 69),
      ))
    }

@delegate:ResourceContentHash(1_976_773_488)
internal val Res.string.profile_cloud_save: StringResource by lazy {
      StringResource("string:profile_cloud_save", "profile_cloud_save", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 200198, 50),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 197478, 54),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 198431, 50),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 189570, 50),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 185250, 42),
      ))
    }

@delegate:ResourceContentHash(-319_528_252)
internal val Res.string.profile_credits_bug_reports: StringResource by lazy {
      StringResource("string:profile_credits_bug_reports", "profile_credits_bug_reports", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 200249, 147),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 197533, 155),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 198482, 171),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 189621, 147),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 185293, 139),
      ))
    }

@delegate:ResourceContentHash(902_639_888)
internal val Res.string.profile_credits_dev: StringResource by lazy {
      StringResource("string:profile_credits_dev", "profile_credits_dev", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 200397, 71),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 197689, 75),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 198654, 83),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 189769, 67),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 185433, 71),
      ))
    }

@delegate:ResourceContentHash(-1_112_201_135)
internal val Res.string.profile_credits_image_note: StringResource by lazy {
      StringResource("string:profile_credits_image_note", "profile_credits_image_note", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 200469, 146),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 197765, 150),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 198738, 166),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 189837, 158),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 185505, 134),
      ))
    }

@delegate:ResourceContentHash(1_813_447_752)
internal val Res.string.profile_credits_image_sources: StringResource by lazy {
      StringResource("string:profile_credits_image_sources", "profile_credits_image_sources", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 200616, 53),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 197916, 69),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 198905, 61),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 189996, 65),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 185640, 57),
      ))
    }

@delegate:ResourceContentHash(-458_616_036)
internal val Res.string.profile_credits_sources: StringResource by lazy {
      StringResource("string:profile_credits_sources", "profile_credits_sources", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 200670, 83),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 197986, 75),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 198967, 83),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 190062, 75),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 185698, 75),
      ))
    }

@delegate:ResourceContentHash(1_476_327_517)
internal val Res.string.profile_credits_title: StringResource by lazy {
      StringResource("string:profile_credits_title", "profile_credits_title", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 200754, 41),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 198062, 41),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 199051, 41),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 190138, 41),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 185774, 41),
      ))
    }

@delegate:ResourceContentHash(-84_738_712)
internal val Res.string.profile_cta_changelog_button: StringResource by lazy {
      StringResource("string:profile_cta_changelog_button", "profile_cta_changelog_button", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 200796, 48),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 198104, 48),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 199093, 48),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 190180, 48),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 185816, 48),
      ))
    }

@delegate:ResourceContentHash(-1_365_852_560)
internal val Res.string.profile_cta_changelog_text: StringResource by lazy {
      StringResource("string:profile_cta_changelog_text", "profile_cta_changelog_text", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 200845, 102),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 198153, 118),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 199142, 126),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 190229, 106),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 185865, 98),
      ))
    }

@delegate:ResourceContentHash(-1_289_292_317)
internal val Res.string.profile_cta_feedback_button: StringResource by lazy {
      StringResource("string:profile_cta_feedback_button", "profile_cta_feedback_button", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 200948, 47),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 198272, 47),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 199269, 47),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 190336, 43),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 185964, 43),
      ))
    }

@delegate:ResourceContentHash(-1_986_877_939)
internal val Res.string.profile_cta_feedback_text: StringResource by lazy {
      StringResource("string:profile_cta_feedback_text", "profile_cta_feedback_text", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 200996, 101),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 198320, 101),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 199317, 105),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 190380, 85),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 186008, 97),
      ))
    }

@delegate:ResourceContentHash(1_642_059_478)
internal val Res.string.profile_cta_more_apps_button: StringResource by lazy {
      StringResource("string:profile_cta_more_apps_button", "profile_cta_more_apps_button", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 201098, 44),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 198422, 44),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 199423, 44),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 190466, 48),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 186106, 44),
      ))
    }

@delegate:ResourceContentHash(1_883_141_479)
internal val Res.string.profile_cta_more_apps_text: StringResource by lazy {
      StringResource("string:profile_cta_more_apps_text", "profile_cta_more_apps_text", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 201143, 86),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 198467, 86),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 199468, 90),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 190515, 78),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 186151, 74),
      ))
    }

@delegate:ResourceContentHash(-718_772_263)
internal val Res.string.profile_cta_rate_button: StringResource by lazy {
      StringResource("string:profile_cta_rate_button", "profile_cta_rate_button", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 201230, 43),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 198554, 43),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 199559, 39),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 190594, 39),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 186226, 39),
      ))
    }

@delegate:ResourceContentHash(-886_516_112)
internal val Res.string.profile_cta_rate_text: StringResource by lazy {
      StringResource("string:profile_cta_rate_text", "profile_cta_rate_text", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 201274, 101),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 198598, 89),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 199599, 93),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 190634, 85),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 186266, 77),
      ))
    }

@delegate:ResourceContentHash(1_353_162_761)
internal val Res.string.profile_debug_actions_title: StringResource by lazy {
      StringResource("string:profile_debug_actions_title", "profile_debug_actions_title", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 201376, 55),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 198688, 55),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 199693, 59),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 190720, 55),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 186344, 55),
      ))
    }

@delegate:ResourceContentHash(-1_509_550_404)
internal val Res.string.profile_default_user: StringResource by lazy {
      StringResource("string:profile_default_user", "profile_default_user", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 201432, 40),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 198744, 40),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 199753, 44),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 190776, 36),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 186400, 36),
      ))
    }

@delegate:ResourceContentHash(-84_466_405)
internal val Res.string.profile_explanations_count: StringResource by lazy {
      StringResource("string:profile_explanations_count", "profile_explanations_count", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 201473, 78),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 198785, 74),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 199798, 78),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 190813, 70),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 186437, 70),
      ))
    }

@delegate:ResourceContentHash(1_409_510_128)
internal val Res.string.profile_perfect_count: StringResource by lazy {
      StringResource("string:profile_perfect_count", "profile_perfect_count", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 201552, 61),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 198860, 65),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 199877, 65),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 190884, 61),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 186508, 57),
      ))
    }

@delegate:ResourceContentHash(2_068_316_247)
internal val Res.string.profile_save_cloud_hint: StringResource by lazy {
      StringResource("string:profile_save_cloud_hint", "profile_save_cloud_hint", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 201614, 115),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 198926, 99),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 199943, 111),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 190946, 95),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 186566, 87),
      ))
    }

@delegate:ResourceContentHash(24_796_612)
internal val Res.string.profile_stars_count: StringResource by lazy {
      StringResource("string:profile_stars_count", "profile_stars_count", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 201730, 63),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 199026, 67),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 200055, 67),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 191042, 63),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 186654, 59),
      ))
    }

@delegate:ResourceContentHash(-1_553_283_046)
internal val Res.string.profile_status_synced: StringResource by lazy {
      StringResource("string:profile_status_synced", "profile_status_synced", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 201794, 61),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 199094, 57),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 200123, 57),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 191106, 57),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 186714, 49),
      ))
    }

@delegate:ResourceContentHash(-1_910_326_156)
internal val Res.string.profile_status_unsynced: StringResource by lazy {
      StringResource("string:profile_status_unsynced", "profile_status_unsynced", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 201856, 71),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 199152, 63),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 200181, 67),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 191164, 63),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 186764, 55),
      ))
    }

@delegate:ResourceContentHash(-1_520_967_962)
internal val Res.string.profile_theme_dark: StringResource by lazy {
      StringResource("string:profile_theme_dark", "profile_theme_dark", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 201928, 34),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 199216, 34),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 200249, 34),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 191228, 34),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 186820, 34),
      ))
    }

@delegate:ResourceContentHash(819_349_690)
internal val Res.string.profile_theme_desc: StringResource by lazy {
      StringResource("string:profile_theme_desc", "profile_theme_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 201963, 74),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 199251, 62),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 200284, 74),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 191263, 62),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 186855, 54),
      ))
    }

@delegate:ResourceContentHash(-606_855_264)
internal val Res.string.profile_theme_light: StringResource by lazy {
      StringResource("string:profile_theme_light", "profile_theme_light", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 202038, 35),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 199314, 35),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 200359, 35),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 191326, 35),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 186910, 35),
      ))
    }

@delegate:ResourceContentHash(656_223_684)
internal val Res.string.profile_theme_system: StringResource by lazy {
      StringResource("string:profile_theme_system", "profile_theme_system", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 202074, 36),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 199350, 40),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 200395, 40),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 191362, 40),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 186946, 36),
      ))
    }

@delegate:ResourceContentHash(-1_745_710_784)
internal val Res.string.profile_theme_title: StringResource by lazy {
      StringResource("string:profile_theme_title", "profile_theme_title", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 202111, 35),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 199391, 35),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 200436, 35),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 191403, 35),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 186983, 35),
      ))
    }

@delegate:ResourceContentHash(431_655_973)
internal val Res.string.profile_title: StringResource by lazy {
      StringResource("string:profile_title", "profile_title", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 202147, 29),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 199427, 29),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 200472, 29),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 191439, 33),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 187019, 33),
      ))
    }

@delegate:ResourceContentHash(-1_688_220_298)
internal val Res.string.profile_tutorial_done: StringResource by lazy {
      StringResource("string:profile_tutorial_done", "profile_tutorial_done", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 202177, 69),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 199457, 65),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 200502, 61),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 191473, 65),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 187053, 61),
      ))
    }

@delegate:ResourceContentHash(1_859_033_532)
internal val Res.string.profile_widget_add_button: StringResource by lazy {
      StringResource("string:profile_widget_add_button", "profile_widget_add_button", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 202247, 49),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 199523, 53),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 200564, 45),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 191539, 45),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 187115, 37),
      ))
    }

@delegate:ResourceContentHash(-1_182_539_249)
internal val Res.string.profile_widget_desc: StringResource by lazy {
      StringResource("string:profile_widget_desc", "profile_widget_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 202297, 131),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 199577, 119),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 200610, 123),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 191585, 119),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 187153, 107),
      ))
    }

@delegate:ResourceContentHash(-774_552_151)
internal val Res.string.profile_widget_title: StringResource by lazy {
      StringResource("string:profile_widget_title", "profile_widget_title", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 202429, 52),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 199697, 52),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 200734, 52),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 191705, 44),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 187261, 44),
      ))
    }

@delegate:ResourceContentHash(1_078_360_980)
internal val Res.string.question_type_meaning: StringResource by lazy {
      StringResource("string:question_type_meaning", "question_type_meaning", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 202482, 53),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 199750, 53),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 200787, 57),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 191750, 49),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 187306, 53),
      ))
    }

@delegate:ResourceContentHash(1_720_406_192)
internal val Res.string.question_type_multipress: StringResource by lazy {
      StringResource("string:question_type_multipress", "question_type_multipress", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 202536, 88),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 199804, 96),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 200845, 100),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 191800, 80),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 187360, 84),
      ))
    }

@delegate:ResourceContentHash(1_002_082_964)
internal val Res.string.question_type_transcribe: StringResource by lazy {
      StringResource("string:question_type_transcribe", "question_type_transcribe", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 202625, 68),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 199901, 64),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 200946, 76),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 191881, 60),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 187445, 68),
      ))
    }

@delegate:ResourceContentHash(-51_300_628)
internal val Res.string.question_type_translate: StringResource by lazy {
      StringResource("string:question_type_translate", "question_type_translate", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 202694, 63),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 199966, 59),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 201023, 63),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 191942, 55),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 187514, 59),
      ))
    }

@delegate:ResourceContentHash(1_457_128_991)
internal val Res.string.quiz_a_capo_direzione_figure: StringResource by lazy {
      StringResource("string:quiz_a_capo_direzione_figure", "quiz_a_capo_direzione_figure", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 202758, 180),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 200026, 180),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 201087, 180),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 191998, 168),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 187574, 156),
      ))
    }

@delegate:ResourceContentHash(1_936_147_952)
internal val Res.string.quiz_a_capo_quaglia_asimmetrica: StringResource by lazy {
      StringResource("string:quiz_a_capo_quaglia_asimmetrica", "quiz_a_capo_quaglia_asimmetrica", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 202939, 199),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 200207, 199),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 201268, 191),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 192167, 191),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 187731, 179),
      ))
    }

@delegate:ResourceContentHash(75_976_984)
internal val Res.string.quiz_a_capo_segni_simmetrici: StringResource by lazy {
      StringResource("string:quiz_a_capo_segni_simmetrici", "quiz_a_capo_segni_simmetrici", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 203139, 228),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 200407, 228),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 201460, 248),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 192359, 220),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 187911, 224),
      ))
    }

@delegate:ResourceContentHash(984_703_550)
internal val Res.string.quiz_a_capo_spezzare_parole: StringResource by lazy {
      StringResource("string:quiz_a_capo_spezzare_parole", "quiz_a_capo_spezzare_parole", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 203368, 187),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 200636, 203),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 201709, 211),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 192580, 163),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 188136, 159),
      ))
    }

@delegate:ResourceContentHash(-1_423_648_598)
internal val Res.string.quiz_a_capo_trattino_obbligatorio: StringResource by lazy {
      StringResource("string:quiz_a_capo_trattino_obbligatorio", "quiz_a_capo_trattino_obbligatorio", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 203556, 153),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 200840, 161),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 201921, 161),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 192744, 145),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 188296, 141),
      ))
    }

@delegate:ResourceContentHash(-1_483_859_186)
internal val Res.string.quiz_aggettivi_genere_tf_1: StringResource by lazy {
      StringResource("string:quiz_aggettivi_genere_tf_1", "quiz_aggettivi_genere_tf_1", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 203710, 106),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 201002, 98),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 202083, 98),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 192890, 94),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 188438, 98),
      ))
    }

@delegate:ResourceContentHash(478_530_209)
internal val Res.string.quiz_aggettivi_genere_tf_2: StringResource by lazy {
      StringResource("string:quiz_aggettivi_genere_tf_2", "quiz_aggettivi_genere_tf_2", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 203817, 122),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 201101, 122),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 202182, 114),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 192985, 114),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 188537, 114),
      ))
    }

@delegate:ResourceContentHash(-1_487_651_642)
internal val Res.string.quiz_aggettivi_genere_tf_3: StringResource by lazy {
      StringResource("string:quiz_aggettivi_genere_tf_3", "quiz_aggettivi_genere_tf_3", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 203940, 146),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 201224, 126),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 202297, 134),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 193100, 126),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 188652, 138),
      ))
    }

@delegate:ResourceContentHash(-1_038_288_206)
internal val Res.string.quiz_aggettivi_genere_tf_4: StringResource by lazy {
      StringResource("string:quiz_aggettivi_genere_tf_4", "quiz_aggettivi_genere_tf_4", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 204087, 78),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 201351, 82),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 202432, 82),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 193227, 82),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 188791, 78),
      ))
    }

@delegate:ResourceContentHash(-299_997_713)
internal val Res.string.quiz_aggettivi_plurale_tf_1: StringResource by lazy {
      StringResource("string:quiz_aggettivi_plurale_tf_1", "quiz_aggettivi_plurale_tf_1", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 204166, 111),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 201434, 115),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 202515, 111),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 193310, 111),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 188870, 115),
      ))
    }

@delegate:ResourceContentHash(-371_233_231)
internal val Res.string.quiz_aggettivi_plurale_tf_2: StringResource by lazy {
      StringResource("string:quiz_aggettivi_plurale_tf_2", "quiz_aggettivi_plurale_tf_2", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 204278, 115),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 201550, 119),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 202627, 123),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 193422, 119),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 188986, 119),
      ))
    }

@delegate:ResourceContentHash(1_787_005_592)
internal val Res.string.quiz_aggettivi_plurale_tf_3: StringResource by lazy {
      StringResource("string:quiz_aggettivi_plurale_tf_3", "quiz_aggettivi_plurale_tf_3", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 204394, 91),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 201670, 95),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 202751, 87),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 193542, 91),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 189106, 79),
      ))
    }

@delegate:ResourceContentHash(142_745_236)
internal val Res.string.quiz_aggettivi_plurale_tf_4: StringResource by lazy {
      StringResource("string:quiz_aggettivi_plurale_tf_4", "quiz_aggettivi_plurale_tf_4", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 204486, 123),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 201766, 119),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 202839, 111),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 193634, 107),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 189186, 107),
      ))
    }

@delegate:ResourceContentHash(1_886_935_798)
internal val Res.string.quiz_aggettivo_sostantivato_da_solo: StringResource by lazy {
      StringResource("string:quiz_aggettivo_sostantivato_da_solo", "quiz_aggettivo_sostantivato_da_solo", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 204610, 127),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 201886, 111),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 202951, 119),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 193742, 99),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 189294, 111),
      ))
    }

@delegate:ResourceContentHash(-163_514_343)
internal val Res.string.quiz_aggettivo_sostantivato_tf_1: StringResource by lazy {
      StringResource("string:quiz_aggettivo_sostantivato_tf_1", "quiz_aggettivo_sostantivato_tf_1", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 204738, 88),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 201998, 92),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 203071, 84),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 193842, 96),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 189406, 92),
      ))
    }

@delegate:ResourceContentHash(694_868_323)
internal val Res.string.quiz_aggettivo_sostantivato_tf_2: StringResource by lazy {
      StringResource("string:quiz_aggettivo_sostantivato_tf_2", "quiz_aggettivo_sostantivato_tf_2", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 204827, 120),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 202091, 112),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 203156, 116),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 193939, 112),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 189499, 112),
      ))
    }

@delegate:ResourceContentHash(-392_140_424)
internal val Res.string.quiz_aggettivo_sostantivato_tf_3: StringResource by lazy {
      StringResource("string:quiz_aggettivo_sostantivato_tf_3", "quiz_aggettivo_sostantivato_tf_3", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 204948, 100),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 202204, 100),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 203273, 108),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 194052, 112),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 189612, 116),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString19Resources(map: MutableMap<String, StringResource>) {
  map.put("month_february", Res.string.month_february)
  map.put("month_january", Res.string.month_january)
  map.put("month_july", Res.string.month_july)
  map.put("month_june", Res.string.month_june)
  map.put("month_march", Res.string.month_march)
  map.put("month_may", Res.string.month_may)
  map.put("month_november", Res.string.month_november)
  map.put("month_october", Res.string.month_october)
  map.put("month_september", Res.string.month_september)
  map.put("must_accept_terms_error", Res.string.must_accept_terms_error)
  map.put("new_user_register_here", Res.string.new_user_register_here)
  map.put("next_month_desc", Res.string.next_month_desc)
  map.put("no_hearts_ad_loading_btn", Res.string.no_hearts_ad_loading_btn)
  map.put("no_hearts_ad_unavailable_btn", Res.string.no_hearts_ad_unavailable_btn)
  map.put("no_hearts_benefit_accessories_desc", Res.string.no_hearts_benefit_accessories_desc)
  map.put("no_hearts_benefit_accessories_title", Res.string.no_hearts_benefit_accessories_title)
  map.put("no_hearts_benefit_builder_desc", Res.string.no_hearts_benefit_builder_desc)
  map.put("no_hearts_benefit_builder_title", Res.string.no_hearts_benefit_builder_title)
  map.put("no_hearts_benefit_hearts_desc", Res.string.no_hearts_benefit_hearts_desc)
  map.put("no_hearts_benefit_hearts_title", Res.string.no_hearts_benefit_hearts_title)
  map.put("no_hearts_benefit_onetime_desc", Res.string.no_hearts_benefit_onetime_desc)
  map.put("no_hearts_benefit_onetime_title", Res.string.no_hearts_benefit_onetime_title)
  map.put("no_hearts_feedback", Res.string.no_hearts_feedback)
  map.put("no_hearts_maybe_later_btn", Res.string.no_hearts_maybe_later_btn)
  map.put("no_hearts_onetime_notice", Res.string.no_hearts_onetime_notice)
  map.put("no_hearts_subtitle", Res.string.no_hearts_subtitle)
  map.put("no_hearts_title", Res.string.no_hearts_title)
  map.put("no_hearts_unlock_btn", Res.string.no_hearts_unlock_btn)
  map.put("no_hearts_upsell_full_version", Res.string.no_hearts_upsell_full_version)
  map.put("no_hearts_wait_tomorrow_sub", Res.string.no_hearts_wait_tomorrow_sub)
  map.put("no_hearts_watch_ad_btn", Res.string.no_hearts_watch_ad_btn)
  map.put("no_hiero_found", Res.string.no_hiero_found)
  map.put("no_rule_found", Res.string.no_rule_found)
  map.put("no_title", Res.string.no_title)
  map.put("no_word_found", Res.string.no_word_found)
  map.put("oh_no_title", Res.string.oh_no_title)
  map.put("or_divider", Res.string.or_divider)
  map.put("password_label", Res.string.password_label)
  map.put("perfect_stars_desc", Res.string.perfect_stars_desc)
  map.put("placeholder_write_translation", Res.string.placeholder_write_translation)
  map.put("plural_dual", Res.string.plural_dual)
  map.put("plural_triple", Res.string.plural_triple)
  map.put("plural_w", Res.string.plural_w)
  map.put("previous_month_desc", Res.string.previous_month_desc)
  map.put("privacy_policy_label", Res.string.privacy_policy_label)
  map.put("profile_alyn_colors_count", Res.string.profile_alyn_colors_count)
  map.put("profile_cloud_save", Res.string.profile_cloud_save)
  map.put("profile_credits_bug_reports", Res.string.profile_credits_bug_reports)
  map.put("profile_credits_dev", Res.string.profile_credits_dev)
  map.put("profile_credits_image_note", Res.string.profile_credits_image_note)
  map.put("profile_credits_image_sources", Res.string.profile_credits_image_sources)
  map.put("profile_credits_sources", Res.string.profile_credits_sources)
  map.put("profile_credits_title", Res.string.profile_credits_title)
  map.put("profile_cta_changelog_button", Res.string.profile_cta_changelog_button)
  map.put("profile_cta_changelog_text", Res.string.profile_cta_changelog_text)
  map.put("profile_cta_feedback_button", Res.string.profile_cta_feedback_button)
  map.put("profile_cta_feedback_text", Res.string.profile_cta_feedback_text)
  map.put("profile_cta_more_apps_button", Res.string.profile_cta_more_apps_button)
  map.put("profile_cta_more_apps_text", Res.string.profile_cta_more_apps_text)
  map.put("profile_cta_rate_button", Res.string.profile_cta_rate_button)
  map.put("profile_cta_rate_text", Res.string.profile_cta_rate_text)
  map.put("profile_debug_actions_title", Res.string.profile_debug_actions_title)
  map.put("profile_default_user", Res.string.profile_default_user)
  map.put("profile_explanations_count", Res.string.profile_explanations_count)
  map.put("profile_perfect_count", Res.string.profile_perfect_count)
  map.put("profile_save_cloud_hint", Res.string.profile_save_cloud_hint)
  map.put("profile_stars_count", Res.string.profile_stars_count)
  map.put("profile_status_synced", Res.string.profile_status_synced)
  map.put("profile_status_unsynced", Res.string.profile_status_unsynced)
  map.put("profile_theme_dark", Res.string.profile_theme_dark)
  map.put("profile_theme_desc", Res.string.profile_theme_desc)
  map.put("profile_theme_light", Res.string.profile_theme_light)
  map.put("profile_theme_system", Res.string.profile_theme_system)
  map.put("profile_theme_title", Res.string.profile_theme_title)
  map.put("profile_title", Res.string.profile_title)
  map.put("profile_tutorial_done", Res.string.profile_tutorial_done)
  map.put("profile_widget_add_button", Res.string.profile_widget_add_button)
  map.put("profile_widget_desc", Res.string.profile_widget_desc)
  map.put("profile_widget_title", Res.string.profile_widget_title)
  map.put("question_type_meaning", Res.string.question_type_meaning)
  map.put("question_type_multipress", Res.string.question_type_multipress)
  map.put("question_type_transcribe", Res.string.question_type_transcribe)
  map.put("question_type_translate", Res.string.question_type_translate)
  map.put("quiz_a_capo_direzione_figure", Res.string.quiz_a_capo_direzione_figure)
  map.put("quiz_a_capo_quaglia_asimmetrica", Res.string.quiz_a_capo_quaglia_asimmetrica)
  map.put("quiz_a_capo_segni_simmetrici", Res.string.quiz_a_capo_segni_simmetrici)
  map.put("quiz_a_capo_spezzare_parole", Res.string.quiz_a_capo_spezzare_parole)
  map.put("quiz_a_capo_trattino_obbligatorio", Res.string.quiz_a_capo_trattino_obbligatorio)
  map.put("quiz_aggettivi_genere_tf_1", Res.string.quiz_aggettivi_genere_tf_1)
  map.put("quiz_aggettivi_genere_tf_2", Res.string.quiz_aggettivi_genere_tf_2)
  map.put("quiz_aggettivi_genere_tf_3", Res.string.quiz_aggettivi_genere_tf_3)
  map.put("quiz_aggettivi_genere_tf_4", Res.string.quiz_aggettivi_genere_tf_4)
  map.put("quiz_aggettivi_plurale_tf_1", Res.string.quiz_aggettivi_plurale_tf_1)
  map.put("quiz_aggettivi_plurale_tf_2", Res.string.quiz_aggettivi_plurale_tf_2)
  map.put("quiz_aggettivi_plurale_tf_3", Res.string.quiz_aggettivi_plurale_tf_3)
  map.put("quiz_aggettivi_plurale_tf_4", Res.string.quiz_aggettivi_plurale_tf_4)
  map.put("quiz_aggettivo_sostantivato_da_solo", Res.string.quiz_aggettivo_sostantivato_da_solo)
  map.put("quiz_aggettivo_sostantivato_tf_1", Res.string.quiz_aggettivo_sostantivato_tf_1)
  map.put("quiz_aggettivo_sostantivato_tf_2", Res.string.quiz_aggettivo_sostantivato_tf_2)
  map.put("quiz_aggettivo_sostantivato_tf_3", Res.string.quiz_aggettivo_sostantivato_tf_3)
}
